<mat-card class="default-card grid-all">
    <mat-card-header>
        <mat-card-title>{{ datas.title }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            @if (datas.items) {
                <div class="drop-list-container">
                    <div id="items" cdkDropList [cdkDropListData]="datas.items" class="drop-list" (cdkDropListDropped)="drop($event)">
                        @for (item of datas.items; track item) {
                            <div class="sort-item drop-item" cdkDrag cdkDragPreview>
                                <fa-icon [icon]="faGripLinesVertical" class="fa-lg drag-handle" cdkDragHandle></fa-icon>
                                <span class="label">{{ item.name }}</span>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" (click)="onDismiss()">Annuler</button>
        <button mat-raised-button class="accent-button" (click)="onConfirm()">Valider</button>
    </mat-card-actions>
</mat-card>
